<template>
    <div class="flex flex-col w-full">
        <label for="text-value" class="block text-sm text-theme-muted mb-1">{{
            label
        }}</label>
        <span id="text-value" class="text-sm text-theme-base px-3 py-2">{{
            value
        }}</span>
    </div>
</template>

<script>
export default {
    name: "TextComponent",
    props: {
        label: {
            type: String,
            default: () => "Label"
        },
        value: {
            type: String,
            default: () => "Value"
        }
    }
};
</script>
